import { useSafeLocalStorage } from 'src/hooks/use-storage';

export const REGULAR_FCFS_DESIGN_OPT_OUT_KEY = 'REGULAR_FCFS_DESIGN_OPT_OUT';

export function useNewFcfsDesign() {
  const safeLocalStorage = useSafeLocalStorage();
  const active = !safeLocalStorage.getItem(REGULAR_FCFS_DESIGN_OPT_OUT_KEY);
  return active;
}
